export enum ServiceRequestStatus {
  draft = "draft",
  active = "active",
  onHold = "on-hold",
  revoked = "revoked",
  completed = "completed",
  enteredInError = "entered-in-error",
  unknown = "unknown",
}
